import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { navegarComCtrl } from "../../utils/solicitacoes/navegacao";
import { CustomTable } from "../../componentes/table/CustomTable";
import { CustomDropdown } from "../../componentes/dropdown/CustomDropdown";
import StatusBadge from "../../components/solicitacoes/Shared/StatusBadge";
import GraficosBasicos from "../../components/solicitacoes/Dashboard/GraficosBasicos";
import DashboardProcessoLayout, { Campo, INPUT_CLASS } from "../../components/solicitacoes/Dashboard/DashboardProcessoLayout";
import { useDashboardProcesso } from "../../hooks/solicitacoes/useDashboardProcesso";
import SolicitacaoAtivosService from "../../services/resource/solicitacaoAtivosService";
import UsuarioService from "../../services/resource/usuarioService";
import { STATUS_CONFIG } from "../../utils/solicitacoes/statusConfig";
import { kpisBasicos } from "../../utils/solicitacoes/chartOptions";
import { RESULTADO_DIGITACAO_LABELS } from "../../components/solicitacoes/DetalheProcesso/DigitacaoAtivosResumo";

const service = new SolicitacaoAtivosService();
const usuarioService = new UsuarioService();

const STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(([value, info]) => ({ value, label: info.label }));

const FILTROS_INICIAIS_EXTRA = {
    filialNome: "", supervisor: "", codigoRota: "", clienteNome: "", status: null, solicitanteId: null,
};

const simNao = v => v == null ? "-" : (v ? "Sim" : "Não");

const COLUNAS = [
    { key: "filialNome", label: "Filial" },
    { key: "codigoRota", label: "Código da Rota" },
    { key: "supervisor", label: "Supervisor" },
    { key: "clienteNome", label: "Cliente" },
    { key: "clienteCodigo", label: "Código Cliente" },
    { key: "clienteRazaoSocial", label: "Razão Social" },
    { key: "clienteFantasia", label: "Nome Fantasia" },
    { key: "clienteCidade", label: "Cidade" },
    { key: "clienteEstado", label: "Estado" },
    { key: "clienteBairro", label: "Bairro" },
    { key: "clienteEncontrado", label: "Cliente Encontrado", render: simNao, center: true },
    { key: "dataPrevistaEntrega", label: "Data Prevista", format: "date" },
    { key: "motivo", label: "Motivo" },
    { key: "quantidadeItens", label: "Qtd. Itens", center: true },
    { key: "justificativaAnalise", label: "Justificativa (Análise)" },
    { key: "resultadoDigitacao", label: "Digitação", render: v => RESULTADO_DIGITACAO_LABELS[v] || v || "-" },
    { key: "numeroPedidoDigitacao", label: "Nº do Pedido" },
    { key: "motivoDigitacao", label: "Motivo (Digitação)" },
    { key: "status", label: "Status", render: v => <StatusBadge status={v} />, center: true },
    { key: "etapaAtual", label: "Etapa Atual" },
    { key: "solicitanteNome", label: "Solicitante" },
    { key: "dataSolicitacao", label: "Data da Solicitação", format: "date" },
];

export default function RelatorioSolicitacaoAtivos() {
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);

    const { filtros, setFiltros, limparFiltros, pesquisar, linhas, dashboard, loading } = useDashboardProcesso({
        service, chaveFiltros: "solicitacoes.solicitacaoAtivos.filtros", filtrosIniciaisExtra: FILTROS_INICIAIS_EXTRA,
    });

    useEffect(() => {
        document.title = "MyDash | Solicitação de Ativos";
    }, []);

    useEffect(() => {
        usuarioService.listarUsuarios().then(res => setUsuarios(res.data)).catch(() => setUsuarios([]));
    }, []);

    function setFiltro(campo, valor) {
        setFiltros(prev => ({ ...prev, [campo]: valor }));
    }

    return (
        <DashboardProcessoLayout
            titulo="Solicitação de Ativos"
            onNovaSolicitacao={() => navigate("/solicitacoes/nova")}
            loading={loading}
            filtros={filtros}
            onFiltroChange={setFiltro}
            onPesquisar={pesquisar}
            onLimparFiltros={limparFiltros}
            kpis={kpisBasicos(dashboard, "fa fa-box-open")}
            graficos={<GraficosBasicos dashboard={dashboard} />}
            filtrosExtras={(
                <>
                    <Campo label="Filial">
                        <input type="text" value={filtros.filialNome} onChange={e => setFiltro("filialNome", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Supervisor">
                        <input type="text" value={filtros.supervisor} onChange={e => setFiltro("supervisor", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Código da Rota">
                        <input type="text" value={filtros.codigoRota} onChange={e => setFiltro("codigoRota", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Cliente">
                        <input type="text" value={filtros.clienteNome} onChange={e => setFiltro("clienteNome", e.target.value)}
                            placeholder="Razão social ou fantasia" className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Status">
                        <CustomDropdown value={filtros.status} onChange={e => setFiltro("status", e.value)} options={STATUS_OPTIONS}
                            placeholder="Todos os status" showClear />
                    </Campo>
                    <Campo label="Solicitante">
                        <CustomDropdown value={filtros.solicitanteId} onChange={e => setFiltro("solicitanteId", e.value)} options={usuarios}
                            optionValue="id" optionLabel="nome" placeholder="Todos os solicitantes" showClear filter />
                    </Campo>
                </>
            )}
        >
            <CustomTable
                data={linhas}
                columns={COLUNAS}
                loading={loading}
                pagination
                pageSize={20}
                showHeader={false}
                className="text-[11px] border shadow-card rounded-xl"
                exportable
                exportFilename="dashboard_solicitacao_ativos"
                footer={() => null}
                onRowSelect={(row, e) => navegarComCtrl(navigate, `/solicitacoes/${row.solicitacaoId}`, e)}
            />
        </DashboardProcessoLayout>
    );
}
